
/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-enable no-unused-vars*/
import { Link } from 'react-router-dom';
import { Form, Field, reduxForm } from 'redux-form';
import { ReduxInput } from '../ReduxInput';
import { isRequired } from '../ReduxInput/Validators';
import { FormGroup, Button, Row, Col } from 'reactstrap';

class ResetPasswordTokenForm extends React.Component {

  render() {
    const { handleSubmit } = this.props;


    return (
      <Form onSubmit={handleSubmit} >
        <FormGroup>

          <Field
            icon="fa-lock"
            tooltip="Don't forget your password"
            type="password"
            name="password"
            placeholder="Password"
            id="password"
            component={ReduxInput}
            validate={[isRequired]}
          />
        </FormGroup>

        <FormGroup>
          <Field
            icon="fa-lock"
            tooltip="Don't forget your password"
            type="password" name="confirm" placeholder="Confirm password"
            component={ReduxInput}
            validate={[isRequired]}
          />
        </FormGroup>
        <FormGroup>
          <Row>

            <Col xs="6">

              <Button id="sign-in-button" type="submit" color="primary">
                Reset
          </Button>
            </Col>
            <Col xs="6" className="text-right">
              <Link to="/login" id="goBack">Go Back to Login</Link>
            </Col>
          </Row>
        </FormGroup>
      </Form>

    );

  }
}

export default reduxForm({
  form: "ResetForm",   // a unique identifier for this form
  destroyOnUnmount: true,         // preserve form data
  forceUnregisterOnUnmount: true,  // unregister fields on unmount
})(ResetPasswordTokenForm);






// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordTokenForm.js